import type { NormalizedCacheObject, TypePolicies } from '@apollo/client';
import { ApolloClient, ApolloLink, from, HttpLink, InMemoryCache } from '@apollo/client';
import { isNull } from 'lodash-es';
import { log } from './log';

export type GetAccessToken = () => string | null;

export const createGraphQLClient = (
  id: string,
  uri: string,
  connectToDevTools: boolean,
  typePolicies: TypePolicies,
  getAccessToken: GetAccessToken,
) => {
  const httpLink = new HttpLink({
    uri,
    // 👇 Enable this to debug GraphQL requests on the HTTP level
    // fetch: async (...args) => {
    //   try {
    //     const response = await fetch(...args);
    //     const clonedResponse = response.clone();
    //     const body = await clonedResponse.json();
    //     log.trace('🔗 response received in HTTP link', JSON.stringify(response), truncateJson(body, 100));
    //     return await response;
    //   } catch (error) {
    //     log.trace('🔗 error received in HTTP link', error);
    //     throw error;
    //   }
    // }
  });

  const authMiddleware = new ApolloLink((operation, forward) => {
    const token = getAccessToken();

    if (!isNull(token)) {
      operation.setContext({
        headers: {
          authorization: `bearer ${token}`,
        },
      });
    }

    return forward(operation);
  });

  // 👇 Add this Apollo Link to debug GraphQL requests on the Apollo level
  // const consoleLink = new ApolloLink((operation, forward) => {
  //   log.trace(`📤 starting request for ${operation.operationName}`, truncateJson(operation.variables));
  //   return forward(operation).map((data) => {
  //     log.trace(`📥 ending request for ${operation.operationName}`, truncateJson(data.data), truncateJson(data.errors));
  //     return data;
  //   });
  // });

  const cache = new InMemoryCache({
    typePolicies,
  });

  log.debug(`Creating Apollo client ${id} for ${uri}.`);

  const client = new ApolloClient({
    cache,
    link: from([authMiddleware, httpLink]),
    connectToDevTools,
  });


  return client;
};

export type GraphQLClient = ApolloClient<NormalizedCacheObject>;
